var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.46 3H5.54C3.59 3 2 4.59 2 6.54V17.47C2 19.41 3.59 21 5.54 21H18.47C20.42 21 22.01 19.41 22.01 17.46V6.54C22 4.59 20.41 3 18.46 3ZM20 17.46C20 18.31 19.31 19 18.46 19H5.54C4.69 19 4 18.31 4 17.46V6.54C4 5.69 4.69 5 5.54 5H18.47C19.31 5 20 5.69 20 6.54V17.46Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C9.10457 11 10 10.1046 10 9C10 7.89543 9.10457 7 8 7C6.89543 7 6 7.89543 6 9C6 10.1046 6.89543 11 8 11Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C9.10457 17 10 16.1046 10 15C10 13.8954 9.10457 13 8 13C6.89543 13 6 13.8954 6 15C6 16.1046 6.89543 17 8 17Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H12V10H18V8Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H12V16H18V14Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssess);
export default __webpack_public_path__ + "static/media/Assess.fe846773a823f7a974ae83ce08a2943f.svg";
export { ForwardRef as ReactComponent };